import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=9de7b934&scoped=true&"
import script from "./ChatRoom.vue?vue&type=script&lang=js&"
export * from "./ChatRoom.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=9de7b934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de7b934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/gate/releases/20261022070252/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9de7b934')) {
      api.createRecord('9de7b934', component.options)
    } else {
      api.reload('9de7b934', component.options)
    }
    module.hot.accept("./ChatRoom.vue?vue&type=template&id=9de7b934&scoped=true&", function () {
      api.rerender('9de7b934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/ChatRoom.vue"
export default component.exports